import React from "react";
import { Link } from "react-scroll";

const Footer = () => {
  return (
    <footer>
      <h3>Thanks for your visit!</h3>
    </footer>
  );
};

export default Footer;
